import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './interview.css';
import { GrUserNew } from "react-icons/gr";
import { useNavigate } from 'react-router-dom'; // Add this import

export default function InterviewerForm() {
    const [formData, setFormData] = useState({
        name: '',
        age: '',
        address: '',
        phone: '',
        email: '',
        idFront: null,
        idBack: null,
        interviewQuestions: null,
        educationalDocs: null,
        notes: ''
    });

    const navigate = useNavigate(); // Initialize the navigate function

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {
            // Validate file type if needed
            if (name === 'interviewQuestions' || name === 'educationalDocs') {
                const fileType = files[0].name.split('.').pop().toLowerCase();
                if (fileType !== 'pdf') {
                    alert('Please upload PDF files for interview questions and educational documents');
                    return;
                }
            }
            setFormData(prev => ({ ...prev, [name]: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleEditorChange = (value) => {
        setFormData(prev => ({ ...prev, notes: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const submissionData = new FormData();
        submissionData.append('name', formData.name);
        submissionData.append('age', formData.age);
        submissionData.append('address', formData.address);
        submissionData.append('phone', formData.phone);
        submissionData.append('email', formData.email);
        submissionData.append('notes', formData.notes);
        submissionData.append('idFront', formData.idFront);
        submissionData.append('idBack', formData.idBack);
        submissionData.append('interviewQuestions', formData.interviewQuestions);
        submissionData.append('educationalDocs', formData.educationalDocs);

        try {
            const response = await fetch('https://backend.ems.uk.hiradentallab.com/api/interviewers/', {
                method: 'POST',
                body: submissionData
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Submission failed');

            alert('Interviewer created successfully!');
            navigate('/interviewers-data'); // Add this line to navigate after success
        } catch (error) {
            console.error('Error:', error);
            alert(error.message || 'An error occurred');
        }

    };


    return (
        <div className="container-fluid">
            <div className="interviewer-container">
                <h1 className="interviewer-title">
                    <GrUserNew className="settings-icon"/> Interviewee Information</h1>
                <hr className="interviewer-divider" />

                <form onSubmit={handleSubmit} className="interviewer-form">
                    <div className="interviewer-card">
                        <h2 className="interviewer-section-title">Personal Details</h2>

                        <div className="interviewer-grid interviewer-grid-cols-2">
                            <div>
                                <label className="interviewer-label">Name*</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter Your Name"
                                    className="interviewer-input"
                                    required
                                />
                            </div>

                            <div>
                                <label className="interviewer-label">Age*</label>
                                <input
                                    type="number"
                                    name="age"
                                    value={formData.age}
                                    onChange={handleChange}
                                    placeholder="Enter Your Age"
                                    className="interviewer-input"
                                    required
                                />
                            </div>

                            <div className="interviewer-grid-cols-2">
                                <label className="interviewer-label">Address*</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="Enter Your Address"
                                    className="interviewer-input"
                                    required
                                />
                            </div>

                            <div>
                                <label className="interviewer-label">Phone Number*</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="Enter Your Phone Number"
                                    className="interviewer-input"
                                    required
                                />
                            </div>

                            <div>
                                <label className="interviewer-label">Email*</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter Your Email"
                                    className="interviewer-input"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div className="interviewer-card">
                        <h2 className="interviewer-section-title">Document Uploads</h2>

                        <div className="interviewer-grid interviewer-grid-cols-2">
                            <div>
                                <label className="interviewer-label">ID Card (Front)*</label>
                                <div className="interviewer-file-input-container">
                                    <input
                                        type="file"
                                        name="idFront"
                                        onChange={handleChange}
                                        className="interviewer-file-input"
                                        required
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="interviewer-label">ID Card (Back)*</label>
                                <div className="interviewer-file-input-container">
                                    <input
                                        type="file"
                                        name="idBack"
                                        onChange={handleChange}
                                        className="interviewer-file-input"
                                        required
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="interviewer-label">Interview Questions (PDF)*</label>
                                <div className="interviewer-file-input-container">
                                    <input
                                        type="file"
                                        name="interviewQuestions"
                                        onChange={handleChange}
                                        accept=".pdf"
                                        className="interviewer-file-input"
                                        required
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="interviewer-label">Educational Documents (PDF)*</label>
                                <div className="interviewer-file-input-container">
                                    <input
                                        type="file"
                                        name="educationalDocs"
                                        onChange={handleChange}
                                        accept=".pdf"
                                        className="interviewer-file-input"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="interviewer-card">
                        <h2 className="interviewer-section-title">Notes</h2>
                        <ReactQuill
                            theme="snow"
                            value={formData.notes}
                            onChange={handleEditorChange}
                            className="interviewer-notes-editor"
                            placeholder="Type your notes here..."
                        />
                    </div>

                    <div className="interviewer-btn-container">
                        <button
                            type="submit"
                            className="interviewer-submit-btn"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}